import {Breadcrumb, Button, Space, Modal, Form, Input, message, Checkbox, Select, Row, Col, Spin, Tag, Typography, Divider, Card, Descriptions} from "antd"
import {Link} from "react-router-dom"
import {
    DashboardOutlined,
    EditOutlined,
    MinusCircleOutlined,
    UserAddOutlined,
    UserOutlined,
    IdcardOutlined,
    MailOutlined,
    PhoneOutlined,
    PlusOutlined,
    DeleteOutlined,
    SaveOutlined,
    SearchOutlined,
    FilterOutlined,
    EyeOutlined
} from "@ant-design/icons"
import {MdPeople} from "react-icons/md";
import {BsGift, BsCalculator} from "react-icons/bs";
import DataTable from "../../components/common/table";
import {useState, useRef, useContext, useEffect, useMemo} from "react";
import UploadButton from "../../components/common/uploadButton";
import {extractValueFromInputRef, scrollToTop} from "../../helpers/dom";
import Header from "../../components/dashboard/header";
import {useCreateUser, useFetchUsers, useGetAllUserStatuses, useUpdateUser} from "../../hooks/user/userQuery";
import {useGetAllUnits} from "../../hooks/unit/unitQuery";
import {useRoles} from "../../hooks/roles/rolesQuery";
import RefreshContext from "../../context/refreshContext";
import {useGetAllLevels, useGetAllSteps} from "../../hooks/payrollData/payrollDataQuery";
import {useGetMemoScope} from "../../hooks/memo-scopes/memoScopeQuery";
import {usePVTypes} from "../../hooks/voucherTypes/voucherTypeQuery";
import {useFetchAllStaffCategories} from "../../hooks/staffcategory/staffCategoryQuery";
import UserBenefitsModal from "../../components/user/benefits/UserBenefitsModal";
import UserDeductionsModal from "../../components/user/deductions/UserDeductionsModal";

const eventBus = document;

const {Option} = Select;

const userTableColumns = [
    {
        title: "S/N",
        key: "s/n",
        render: (_, __, idx) => idx + 1
    },
    {
        title: "User Id",
        key: "userId",
        render: (_, user) => user.userStatus === 'ACTIVE' ? <span style={{color: 'green'}}>{user.userId}</span> :
            <span style={{color: 'red'}}>{user.userId}</span>
    },
    {
        title: "Name",
        dataIndex: "name",
        key: "name"
    },
    // {
    //     title: "Email",
    //     dataIndex: "email",
    //     key: "email",
    // },
    {
        title: "Unit",
        dataIndex: "unit",
        key: "unit",
        render: (_, {unit}) => unit?.title
    },
    {
        title: "Roles",
        dataIndex: "roles",
        key: "roles",
        width: "20%",
        render: (_, {roles}) => (
            <>
                {
                    roles.map((role, idx) => <Tag color="blue"
                                                  key={idx}>{`${role.toLowerCase().replace(/_/g, " ")}, `}</Tag>)
                }
            </>
        )
    },
    {
        title: "Actions",
        key: "actions",
        render: (_, user) => (
            <UserEdit user={user}/>
        )
    }
]


function UserEdit({user}) {
    const [isEditOpen, setIsEditOpen] = useState(false);
    const [unit, setUnit] = useState(user.unit?.id);
    const [userRoles, setUserRoles] = useState(user.roles);
    const [level, setLevel] = useState(user.level?.id);
    const [step, setStep] = useState(user.step?.id);
    const [tmpSteps, setTmpSteps] = useState([]);
    const [isBenefitsModalVisible, setIsBenefitsModalVisible] = useState(false);
    const [isDeductionsModalVisible, setIsDeductionsModalVisible] = useState(false);
    const [isViewOpen, setIsViewOpen] = useState(false);
    const [status, setStatus] = useState(user.userStatus);
    const {flag, setFlag} = useContext(RefreshContext);
    const [roleSelects, setRoleSelects] = useState([]);
    const [userCategory, setUserCategory] = useState(user.staffCategory?.id);

    const [form] = Form.useForm()
    const {units} = useGetAllUnits();
    const {categories} = useFetchAllStaffCategories(flag);

    const nameRef = useRef(null);
    const emailRef = useRef(null);
    const phoneRef = useRef(null);
    const userIdRef = useRef(null);
    const bankNameRef = useRef(null);
    const bankSortRef = useRef(null);
    const accountNumberRef = useRef(null);

    const {levels} = useGetAllLevels();
    const {steps} = useGetAllSteps();
    const {statuses} = useGetAllUserStatuses();

    const showEditModal = () => setIsEditOpen(true);
    const hideEditModal = () => setIsEditOpen(false);

    // Modal visibility handlers for benefits and deductions
    const showBenefitsModal = () => setIsBenefitsModalVisible(true);
    const hideBenefitsModal = () => setIsBenefitsModalVisible(false);
    const showDeductionsModal = () => setIsDeductionsModalVisible(true);
    const hideDeductionsModal = () => setIsDeductionsModalVisible(false);
    const showViewModal = () => setIsViewOpen(true);
    const hideViewModal = () => setIsViewOpen(false);

    const updateUser = useUpdateUser()

    const officeScopes = useGetMemoScope();

    const roles = useRoles().map((ur) => ({label: ur?.name, value: ur?.value}));

    useEffect(() => {
        // register our events we want to listen to
        eventBus.addEventListener("custom:edit", e => {
            setRoleSelects(user?.userRoles?.map(e => ({...e, key: (new Date() + Math.random())})) ?? [])
        });
        if(user.level?.id){
            setTmpSteps(
                steps.filter(e => e.level?.id == level)
            )
        }
        scrollToTop();
    }, []);

    const handleSubmit = async () => {
        const payload = {
            name: extractValueFromInputRef(nameRef),
            email: extractValueFromInputRef(emailRef),
            phone: extractValueFromInputRef(phoneRef),
            userId: extractValueFromInputRef(userIdRef),
            bankName: extractValueFromInputRef(bankNameRef),
            bankSort: extractValueFromInputRef(bankSortRef),
            accountNumber: extractValueFromInputRef(accountNumberRef),
            unit: unit.toString(),
            roles: roleSelects,
            status: status,
            step: step,
            level: level,
            staffCategory: userCategory
        }
        const {message: response} = await updateUser(user.id, payload);
        message.success(response ?? "User data updated successful");
        setIsEditOpen(false);
        setFlag(!flag);
        form.resetFields();
    }

    useEffect(() => {
        // console.log(level)
        if(level){
            setTmpSteps(
                steps.filter(e => e.level?.id == level)
            )
        }
    }, [level])

    const dispatchEditEvent = () => {
        console.log("Emiiting..")
        const addEvent = new CustomEvent("custom:edit", {detail: {user: user}});
        eventBus.dispatchEvent(addEvent);
        showEditModal()
    }

    const handleAddRole = () => {
        const newSelects = [...roleSelects, {key: Date.now()}];
        setRoleSelects(newSelects);
    };

    const handleRemoveRole = (keyToRemove) => {
        const updatedSelects = roleSelects.filter((select) => select.key !== keyToRemove);
        setRoleSelects(updatedSelects);
    };

    const handleModifyRoles = (key, key2, value) => {
        const updatedSelects = roleSelects.map((select) => {
            if (select.key === key) {
                select[key2] = value
            }

            return select
        });

        setRoleSelects(updatedSelects);
    }

    return (
        <>
            <Space size="small" wrap>
                <Button type="default" onClick={showViewModal}>
                    <EyeOutlined/>
                    View
                </Button>
                <Button type="primary" onClick={dispatchEditEvent}>
                    <EditOutlined/>
                    Edit
                </Button>
                <Button type="primary" style={{ backgroundColor: '#52c41a' }} onClick={showBenefitsModal}>
                    <BsGift style={{ marginRight: '4px' }} />
                    Benefits
                </Button>
                <Button type="primary" style={{ backgroundColor: '#722ed1' }} onClick={showDeductionsModal}>
                    <BsCalculator style={{ marginRight: '4px' }} />
                    Deductions
                </Button>
            </Space>
            <Modal
                centered
                title={<Typography.Title level={4}><EditOutlined /> Update User Data</Typography.Title>}
                open={isEditOpen}
                footer={null}
                onCancel={hideEditModal}
                width={700}
            >
                <div style={{
                    maxHeight: "70vh",
                    overflowY: "auto",
                    padding: "0 1em"
                }}>
                    <Form
                        layout="vertical"
                        form={form}
                        requiredMark={false}
                        initialValues={{
                            ...user,
                            step: user?.step?.id ?? null,
                            level: user?.level?.id ?? null,
                            staffCategory: user?.staffCategory?.id ?? null,
                            bankName: user?.bankName ?? '',
                            bankSort: user?.bankSort ?? '',
                            accountNumber: user?.accountNumber ?? ''
                        }}
                    >
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Name"
                                    name="name"
                                >
                                    <Input
                                        prefix={<UserOutlined />}
                                        placeholder="Enter full name"
                                        ref={nameRef}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="User ID"
                                    name="userId"
                                >
                                    <Input
                                        prefix={<IdcardOutlined />}
                                        placeholder="Enter user ID"
                                        ref={userIdRef}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Email"
                                    name="email"
                                >
                                    <Input
                                        prefix={<MailOutlined />}
                                        placeholder="Enter email address"
                                        ref={emailRef}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Phone"
                                    name="phone"
                                >
                                    <Input
                                        prefix={<PhoneOutlined />}
                                        placeholder="Enter phone number"
                                        ref={phoneRef}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item
                                    label="Bank Name"
                                    name="bankName"
                                >
                                    <Input
                                        placeholder="Enter bank name"
                                        ref={bankNameRef}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Bank Sort Code"
                                    name="bankSort"
                                >
                                    <Input
                                        placeholder="Enter sort code"
                                        ref={bankSortRef}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Account Number"
                                    name="accountNumber"
                                >
                                    <Input
                                        placeholder="Enter account number"
                                        ref={accountNumberRef}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Unit"
                                    name="unit"
                                >
                                    <Select
                                        showSearch
                                        placeholder="Select unit"
                                        onChange={(e) => setUnit(e)}
                                        optionFilterProp="children"
                                    >
                                        {units.map((unit, idx) => (
                                            <Option key={idx} value={unit.id}>{unit.title}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Status"
                                    name="userStatus"
                                >
                                    <Select
                                        placeholder="Select user status"
                                        onChange={(e) => setStatus(e)}
                                    >
                                        {statuses.map((s, idx) => (
                                            <Option value={s.value} key={idx}>{s.name}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Category"
                                    name="staffCategory"
                                >
                                    <Select
                                        placeholder="Select user category"
                                        onChange={(e) => setUserCategory(e)}
                                    >
                                        {categories.map((l, idx) => (
                                            <Option value={l.id} key={idx}>{l.title}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Level"
                                    name="level"
                                >
                                    <Select
                                        placeholder="Select user level"
                                        onChange={(e) => setLevel(e)}
                                    >
                                        {levels.map((l, idx) => (
                                            <Option value={l.id} key={idx}>{l.title}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Step"
                                    name="step"
                                >
                                    <Select
                                        showSearch
                                        placeholder="Select user step"
                                        onChange={(e) => setStep(e)}
                                        optionFilterProp="children"
                                    >
                                        {tmpSteps.map((s, idx) => (
                                            <Option value={s.id} key={idx}>{s.title}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider orientation="left">User Roles</Divider>

                        <Form.Item name={'roles'}>
                            <div style={{ marginBottom: '1rem' }}>
                                <Button
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={handleAddRole}
                                >
                                    Add Role
                                </Button>
                            </div>

                            {roleSelects.map((select, index) => (
                                <Card
                                    key={select.key}
                                    size="small"
                                    style={{ marginBottom: '0.8rem' }}
                                    extra={
                                        <Button
                                            type="text"
                                            danger
                                            icon={<DeleteOutlined />}
                                            onClick={() => handleRemoveRole(select.key)}
                                        />
                                    }
                                >
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item
                                                label="Role"
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Select
                                                    value={select.role}
                                                    onChange={(e) => handleModifyRoles(select.key, "role", e)}
                                                    placeholder="Select role"
                                                >
                                                    {roles.map((role, idx) => (
                                                        <Option key={idx} value={role.value}>{role.name}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                label="Scope"
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Select
                                                    value={select.scope}
                                                    onChange={(e) => handleModifyRoles(select.key, "scope", e)}
                                                    placeholder="Select scope"
                                                >
                                                    <Option key={999999} value={null}>None</Option>
                                                    {officeScopes.map((scope, idx) => (
                                                        <Option key={idx} value={scope.value}>{scope.name}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                            ))}
                        </Form.Item>

                        <Form.Item style={{ marginTop: '1.5rem', textAlign: 'right' }}>
                            <Space>
                                <Button onClick={hideEditModal}>
                                    Cancel
                                </Button>
                                <Button
                                    type="primary"
                                    icon={<SaveOutlined />}
                                    onClick={handleSubmit}
                                >
                                    Update User
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>

            {/* User Benefits Modal */}
            <UserBenefitsModal
                visible={isBenefitsModalVisible}
                onCancel={hideBenefitsModal}
                userId={user.id}
            />

            {/* User Deductions Modal */}
            <UserDeductionsModal
                visible={isDeductionsModalVisible}
                onCancel={hideDeductionsModal}
                userId={user.id}
            />

            {/* User View Modal */}
            <Modal
                title="User Details"
                open={isViewOpen}
                footer={[<Button key="close" onClick={hideViewModal}>Close</Button>]}
                onCancel={hideViewModal}
                width={700}
            >
                <Descriptions bordered column={2} size="small">
                    <Descriptions.Item label="Name" span={2}>
                        <strong>{user?.name}</strong>
                    </Descriptions.Item>
                    <Descriptions.Item label="User ID">
                        {user?.userId}
                    </Descriptions.Item>
                    <Descriptions.Item label="Status">
                        <Tag color={user?.userStatus === 'ACTIVE' ? 'green' : 'red'}>
                            {user?.userStatus}
                        </Tag>
                    </Descriptions.Item>
                    <Descriptions.Item label="Email">
                        {user?.email}
                    </Descriptions.Item>
                    <Descriptions.Item label="Phone">
                        {user?.phone}
                    </Descriptions.Item>
                    <Descriptions.Item label="Unit" span={2}>
                        {user?.unit?.title}
                    </Descriptions.Item>
                    <Descriptions.Item label="Bank Name">
                        {user?.bankName || 'Not specified'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Bank Sort Code">
                        {user?.bankSort || 'Not specified'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Account Number" span={2}>
                        {user?.accountNumber || 'Not specified'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Staff Category">
                        {user?.staffCategory?.title || 'Not assigned'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Level">
                        {user?.level?.title || 'Not assigned'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Step" span={2}>
                        {user?.step?.title || 'Not assigned'}
                    </Descriptions.Item>
                    <Descriptions.Item label="Roles" span={2}>
                        <Space wrap>
                            {user?.roles?.map((role, idx) => (
                                <Tag key={idx} color="blue">
                                    {role.replace(/_/g, ' ').toLowerCase()}
                                </Tag>
                            ))}
                        </Space>
                    </Descriptions.Item>
                </Descriptions>
            </Modal>
        </>
    )
}


export default function UsersPage() {
    const [isOpen, setIsOpen] = useState(false);
    const [unit, setUnit] = useState('');
    const [status, setStatus] = useState("");
    const [level, setLevel] = useState("");
    const [step, setStep] = useState("");
    const [tmpSteps, setTmpSteps] = useState([]);
    const [userCategory, setUserCategory] = useState(null);
    const [r, setR] = useState([]);
    const [roleSelects, setRoleSelects] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageSize, setPageSize] = useState(10);

    // Filter state variables
    const [filterSalaryStructure, setFilterSalaryStructure] = useState("");
    const [filterStaffCategory, setFilterStaffCategory] = useState("");
    const [filterLevel, setFilterLevel] = useState("");
    const [filterStep, setFilterStep] = useState("");
    const [filterSearch, setFilterSearch] = useState("");
    const [filterRole, setFilterRole] = useState("");
    const [showFilters, setShowFilters] = useState(false);

    const [form] = Form.useForm();

    const {flag, setFlag} = useContext(RefreshContext);

    useEffect(() => {
        scrollToTop();
    }, []);

    const {units} = useGetAllUnits(flag);
    const {levels} = useGetAllLevels();
    const {steps} = useGetAllSteps();
    const {statuses} = useGetAllUserStatuses();
    const roles = useRoles(flag);
    const officeScopes = useGetMemoScope();
    const {structures} = usePVTypes(flag);
    const {categories} = useFetchAllStaffCategories(flag);

    const showCreateModal = () => setIsOpen(true);
    const hideCreateModal = () => setIsOpen(false);

    const nameRef = useRef(null);
    const emailRef = useRef(null);
    const phoneRef = useRef(null);
    const userIdRef = useRef(null);
    const bankNameRef = useRef(null);
    const bankSortRef = useRef(null);
    const accountNumberRef = useRef(null);

    const createUser = useCreateUser();

    // Create filters object with useMemo to prevent unnecessary re-renders
    const filters = useMemo(() => ({
        salaryStructure: filterSalaryStructure || undefined,
        staffCategory: filterStaffCategory || undefined,
        level: filterLevel || undefined,
        step: filterStep || undefined,
        search: filterSearch || undefined,
        role: filterRole || undefined
    }), [filterSalaryStructure, filterStaffCategory, filterLevel, filterStep, filterSearch, filterRole]);

    // Reset to first page when filters change
    useEffect(() => {
        if (currentPage !== 1) {
            setCurrentPage(1);
        }
    }, [filterSalaryStructure, filterStaffCategory, filterLevel, filterStep, filterSearch, filterRole]);

    // API uses 0-based indexing for pages
    const {loading, users, totalElements} = useFetchUsers(flag, currentPage - 1, pageSize, filters);

    const handlePageChange = (page, size) => {
        setCurrentPage(page);
        setPageSize(size);
    };

    useEffect(() => {
        // console.log("New", level, steps)
        if(level){
            setTmpSteps(
                steps.filter(e => e.level?.id == level)
            )
        }
    }, [level])

    const handleSubmit = async () => {
        const payload = {
            name: nameRef.current.input.value,
            email: emailRef.current.input.value,
            phone: phoneRef.current.input.value,
            userId: userIdRef.current.input.value,
            bankName: bankNameRef.current.input.value,
            bankSort: bankSortRef.current.input.value,
            accountNumber: accountNumberRef.current.input.value,
            unit: unit.toString(),
            roles: roleSelects,
            status,
            step,
            level,
            staffCategory: userCategory
        }
        const {message: response} = await createUser({...payload});
        message.success(response ?? "user added successful");
        form.resetFields();
        setIsOpen(false);
        setFlag(!flag);
    }

    const handleAddRole = () => {
        const newSelects = [...roleSelects, {key: Date.now()}];
        setRoleSelects(newSelects);
    };

    const handleRemoveRole = (keyToRemove) => {
        const updatedSelects = roleSelects.filter((select) => select.key !== keyToRemove);
        setRoleSelects(updatedSelects);
    };

    const handleModifyRoles = (key, key2, value) => {
        const updatedSelects = roleSelects.map((select) => {
            if (select.key === key) {
                select[key2] = value
            }

            return select
        });

        setRoleSelects(updatedSelects);
    }

    return (
        <>
            <div className="main-container">
                <Header/>
                <div className="main-body">

                    <div className="info-bar">
                        <Breadcrumb>
                            <Breadcrumb.Item>
                                <DashboardOutlined className="dashboard-icon"/>
                                <Link to={"/dashboard"}>Dashboard</Link>
                            </Breadcrumb.Item>
                            <Breadcrumb.Item>
                                <MdPeople/>
                                <Link to="/dashboard/users"> Users</Link>
                            </Breadcrumb.Item>
                        </Breadcrumb>
                        <div style={{display: 'flex', gap: '1em'}}>
                            <Button
                                type={showFilters ? "primary" : "default"}
                                icon={<FilterOutlined />}
                                onClick={() => setShowFilters(!showFilters)}
                            >
                                Filters
                            </Button>
                            <UploadButton/>
                            <Button style={{backgroundColor: "green", color: "#FFFFFF"}} onClick={showCreateModal}>
                                <UserAddOutlined/>
                                Add user
                            </Button>
                        </div>
                    </div>

                    {showFilters && (
                        <div className="filter-section" style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f5f5f5', borderRadius: '5px' }}>
                            <Row gutter={[16, 16]}>
                                <Col xs={24} sm={12} md={8} lg={6}>
                                    <Input
                                        placeholder="Search by name, email, or ID"
                                        prefix={<SearchOutlined />}
                                        value={filterSearch}
                                        onChange={(e) => {
                                            setFilterSearch(e.target.value);
                                        }}
                                        allowClear
                                        onClear={() => {
                                            setFilterSearch("");
                                        }}
                                    />
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6}>
                                    <Select
                                        placeholder="Filter by Salary Structure"
                                        style={{ width: '100%' }}
                                        value={filterSalaryStructure || undefined}
                                        onChange={(value) => {
                                            setFilterSalaryStructure(value);
                                        }}
                                        allowClear
                                    >
                                        {structures.map((structure, idx) => (
                                            <Option key={idx} value={structure.id}>{structure.title}</Option>
                                        ))}
                                    </Select>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6}>
                                    <Select
                                        placeholder="Filter by Staff Category"
                                        style={{ width: '100%' }}
                                        value={filterStaffCategory || undefined}
                                        onChange={(value) => {
                                            setFilterStaffCategory(value);
                                        }}
                                        allowClear
                                    >
                                        {categories.map((category, idx) => (
                                            <Option key={idx} value={category.id}>{category.title}</Option>
                                        ))}
                                    </Select>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6}>
                                    <Select
                                        placeholder="Filter by Level"
                                        style={{ width: '100%' }}
                                        value={filterLevel || undefined}
                                        onChange={(value) => {
                                            setFilterLevel(value);
                                        }}
                                        allowClear
                                    >
                                        {levels.map((level, idx) => (
                                            <Option key={idx} value={level.id}>{level.title}</Option>
                                        ))}
                                    </Select>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6}>
                                    <Select
                                        placeholder="Filter by Step"
                                        style={{ width: '100%' }}
                                        value={filterStep || undefined}
                                        onChange={(value) => {
                                            setFilterStep(value);
                                        }}
                                        allowClear
                                    >
                                        {steps.map((step, idx) => (
                                            <Option key={idx} value={step.id}>{step.title}</Option>
                                        ))}
                                    </Select>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6}>
                                    <Select
                                        placeholder="Filter by Role"
                                        style={{ width: '100%' }}
                                        value={filterRole || undefined}
                                        onChange={(value) => {
                                            setFilterRole(value);
                                        }}
                                        allowClear
                                    >
                                        {roles.map((role, idx) => (
                                            <Option key={idx} value={role.value}>{role.name}</Option>
                                        ))}
                                    </Select>
                                </Col>
                                <Col xs={24} sm={12} md={8} lg={6}>
                                    <Button
                                        onClick={() => {
                                            setFilterSalaryStructure("");
                                            setFilterStaffCategory("");
                                            setFilterLevel("");
                                            setFilterStep("");
                                            setFilterSearch("");
                                            setFilterRole("");
                                            setCurrentPage(1);
                                            setFlag(!flag);
                                        }}
                                        type="primary"
                                        danger
                                    >
                                        Clear All Filters
                                    </Button>
                                </Col>
                            </Row>
                        </div>
                    )}

                    <div className="table-section">
                        <Spin spinning={loading}>
                            <DataTable
                                cols={userTableColumns}
                                data={users}
                                perPage={pageSize}
                                totalElements={totalElements}
                                onPageChange={handlePageChange}
                            />
                        </Spin>
                    </div>
                </div>
            </div>
            <Modal
                centered
                title={<Typography.Title level={4}><UserAddOutlined /> Add User</Typography.Title>}
                open={isOpen}
                footer={null}
                onCancel={hideCreateModal}
                width={700}
            >
                <div style={{
                    maxHeight: "70vh",
                    overflowY: "auto",
                    padding: "0 1em"
                }}>
                    <Form
                        layout="vertical"
                        form={form}
                        requiredMark={false}
                    >
                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Name"
                                    name="name"
                                    rules={[{ required: true, message: 'Please input user name!' }]}
                                >
                                    <Input
                                        prefix={<UserOutlined />}
                                        placeholder="Enter full name"
                                        ref={nameRef}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="User ID"
                                    name="userId"
                                    rules={[{ required: true, message: 'Please input user ID!' }]}
                                >
                                    <Input
                                        prefix={<IdcardOutlined />}
                                        placeholder="Enter user ID"
                                        ref={userIdRef}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Email"
                                    name="email"
                                    rules={[{ required: true, type: "email", message: 'Please input valid email!' }]}
                                >
                                    <Input
                                        prefix={<MailOutlined />}
                                        placeholder="Enter email address"
                                        ref={emailRef}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Phone"
                                    name="phone"
                                    rules={[{ required: true, message: 'Please input phone number!' }]}
                                >
                                    <Input
                                        prefix={<PhoneOutlined />}
                                        placeholder="Enter phone number"
                                        ref={phoneRef}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={8}>
                                <Form.Item
                                    label="Bank Name"
                                    name="bankName"
                                    rules={[{ required: true, message: 'Please input bank name!' }]}
                                >
                                    <Input
                                        placeholder="Enter bank name"
                                        ref={bankNameRef}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Bank Sort Code"
                                    name="bankSort"
                                    rules={[{ required: true, message: 'Please input bank sort code!' }]}
                                >
                                    <Input
                                        placeholder="Enter sort code"
                                        ref={bankSortRef}
                                    />
                                </Form.Item>
                            </Col>
                            <Col span={8}>
                                <Form.Item
                                    label="Account Number"
                                    name="accountNumber"
                                    rules={[{ required: true, message: 'Please input account number!' }]}
                                >
                                    <Input
                                        placeholder="Enter account number"
                                        ref={accountNumberRef}
                                    />
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Unit"
                                    name="unit"
                                >
                                    <Select
                                        showSearch
                                        placeholder="Select unit"
                                        onChange={(e) => setUnit(e)}
                                        optionFilterProp="children"
                                    >
                                        {units.map((unit, idx) => (
                                            <Option key={idx} value={unit.id}>{unit.title}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Status"
                                    name="status"
                                >
                                    <Select
                                        placeholder="Select user status"
                                        onChange={(e) => setStatus(e)}
                                    >
                                        {statuses.map((s, idx) => (
                                            <Option value={s.value} key={idx}>{s.name}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Category"
                                    name="category"
                                >
                                    <Select
                                        placeholder="Select user category"
                                        onChange={(e) => setUserCategory(e)}
                                    >
                                        {categories.map((l, idx) => (
                                            <Option value={l.id} key={idx}>{l.title}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col span={12}>
                                <Form.Item
                                    label="Level"
                                    name="level"
                                >
                                    <Select
                                        placeholder="Select user level"
                                        onChange={(e) => setLevel(e)}
                                    >
                                        {levels.map((l, idx) => (
                                            <Option value={l.id} key={idx}>{l.title}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col span={12}>
                                <Form.Item
                                    label="Step"
                                    name="step"
                                >
                                    <Select
                                        showSearch
                                        placeholder="Select user step"
                                        onChange={(e) => setStep(e)}
                                        optionFilterProp="children"
                                    >
                                        {tmpSteps.map((s, idx) => (
                                            <Option value={s.id} key={idx}>{s.title}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>

                        <Divider orientation="left">User Roles</Divider>

                        <Form.Item>
                            <div style={{ marginBottom: '1rem' }}>
                                <Button
                                    type="primary"
                                    icon={<PlusOutlined />}
                                    onClick={handleAddRole}
                                >
                                    Add Role
                                </Button>
                            </div>

                            {roleSelects.map((select, index) => (
                                <Card
                                    key={select.key}
                                    size="small"
                                    style={{ marginBottom: '0.8rem' }}
                                    extra={
                                        <Button
                                            type="text"
                                            danger
                                            icon={<DeleteOutlined />}
                                            onClick={() => handleRemoveRole(select.key)}
                                        />
                                    }
                                >
                                    <Row gutter={16}>
                                        <Col span={12}>
                                            <Form.Item
                                                label="Role"
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Select
                                                    onChange={(e) => handleModifyRoles(select.key, "role", e)}
                                                    placeholder="Select role"
                                                >
                                                    {roles.map((role, idx) => (
                                                        <Option key={idx} value={role.value}>{role.name}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                        <Col span={12}>
                                            <Form.Item
                                                label="Scope"
                                                style={{ marginBottom: 0 }}
                                            >
                                                <Select
                                                    onChange={(e) => handleModifyRoles(select.key, "scope", e)}
                                                    placeholder="Select scope"
                                                >
                                                    <Option key={999991} value={null}>None</Option>
                                                    {officeScopes.map((scope, idx) => (
                                                        <Option key={idx} value={scope.value}>{scope.name}</Option>
                                                    ))}
                                                </Select>
                                            </Form.Item>
                                        </Col>
                                    </Row>
                                </Card>
                            ))}
                        </Form.Item>

                        <Form.Item style={{ marginTop: '1.5rem', textAlign: 'right' }}>
                            <Space>
                                <Button onClick={hideCreateModal}>
                                    Cancel
                                </Button>
                                <Button
                                    type="primary"
                                    icon={<SaveOutlined />}
                                    onClick={handleSubmit}
                                >
                                    Add User
                                </Button>
                            </Space>
                        </Form.Item>
                    </Form>
                </div>
            </Modal>
        </>
    )
}
